import { useQuery } from "@tanstack/react-query";
import { fetchEmployee } from "src/Pages/Company/OrganizationStructure/api";

const useGetEmployee = ({
  enabled,
  employeeId,
}: {
  enabled: boolean;
  employeeId: string;
}) =>
  useQuery({
    enabled,
    queryKey: ["orgchartSearchEmployee", employeeId],
    queryFn: async () => fetchEmployee(employeeId),
  });

export default useGetEmployee;
